<template>
  <section>
    <fixed-header title="Accounting" hideBackBtn />
    <b-row>
      <b-col cols="9">
        <b-row>
          <b-card>
            <template v-slot:header>
              <div class="d-flex justify-content-between">
                <h6 class="mb-0 mr-2">Accounts Receivable</h6>
                <div class="buttons-panel" v-if="checkClaim(CAN_POST_PAYMENT)">
                  <b-button size="sm" class="mr-2" variant="primary" to="receivepayments">
                    <i class="fa fa-list" aria-hidden="true"></i>
                    Payments
                  </b-button>
                  <b-button size="sm" class="mr-2" variant="primary" @click="redirectToReceivePayment">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                    Receive Payment
                  </b-button>
                </div>
              </div>
            </template>
            <invoices isAccountPage :isClear="isClear" v-if="checkClaim(CAN_VIEW_ALL_INVOICES)" @rowSelect="invoiceRowSelect" />
          </b-card>
        </b-row>
        <b-row>
          <b-card>
            <template v-slot:header>
              <div class="d-flex justify-content-between">
                <h6 class="mb-0 mr-2">Accounts Payable</h6>
                <div class="buttons-panel" v-if="checkClaim(CAN_POST_PAYMENT)">
                  <b-button size="sm" class="mr-2" variant="primary" to="billpayments">
                    <i class="fa fa-list" aria-hidden="true"></i>
                    Payments
                  </b-button>
                </div>
              </div>
            </template>
            <b-tabs class="d-flex flex-column" v-if="checkClaim(CAN_VIEW_ALL_POS) || checkClaim(CAN_VIEW_ALL_WORK_ORDERS)">
              <b-tab title="Purchase Orders" v-if="checkClaim(CAN_VIEW_ALL_POS)">
                <purchase-orders :isClear="isClear" isAccountPage filterPageName="accountPagePoTab" />
              </b-tab>
              <b-tab title="Work Orders" v-if="checkClaim(CAN_VIEW_ALL_WORK_ORDERS)">
                <service-orders :isClear="isClear" isAccountPage />
              </b-tab>
            </b-tabs>
          </b-card>
        </b-row>
      </b-col>
      <b-col cols="3">
        <b-row>
          <!--style="max-height: 400px; height: 300px;"-->
          <!--:style="summeryCardHeight"-->
          <b-card v-if="checkClaim(CAN_VIEW_CREDIT_MEMO)" header-class="margin-top-fixed-header" body-class="w-auto p-1">
            <template v-slot:header>
              <div class="d-flex justify-content-between">
                <h6 class="mb-0">Credit Memos</h6>
                <div class="buttons-panel">
                  <b-button v-if="checkClaim(CAN_VIEW_CREDIT_MEMO)" size="sm" class="mr-2" title="Credit Memo List" variant="primary" @click="creditPage()">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </b-button>
                  <b-button v-if="checkClaim(CAN_ADD_CREDIT_MEMO)" size="sm" class="mr-2" title="Add Credit Memo" variant="primary" @click="creditPage(true)">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </b-button>
                </div>
              </div>
            </template>
            <grid-component
              :gridId="creditMemoGridId"
              :itemData="creditMemoitemData"
              :fields="credtMemoSummaryFields"
              :styleCustom="'height: 170px'"
              :onEdit="redirectCreditMemo"
            />
          </b-card>
        </b-row>
        <b-row>
          <!--style="max-height: 400px; height: 300px;"-->
          <!--:style="summeryCardHeight"-->
          <!--header-class="margin-top-fixed-header"-->
          <b-card body-class="w-auto p-1">
            <template v-slot:header>
              <div class="d-flex justify-content-between">
                <h6 class="mb-0">Revenue</h6>
              </div>
            </template>
            <grid-component
              :gridId="revenueGridId"
              :itemData="revenueSummaryData"
              :fields="revenueFields"
              :styleCustom="'height: 170px'"
              :onEdit="redirectInvoices"
            />
          </b-card>
        </b-row>
        <b-row>
          <!--style="max-height: 400px; height: 300px;"-->
          <!--:style="summeryCardHeight"-->
          <!--header-class="margin-top-fixed-header"-->
          <b-card body-class="w-auto p-1">
            <template v-slot:header>
              <div class="d-flex justify-content-between">
                <h6 class="mb-0">Expenses</h6>
                <div class="buttons-panel">
                  <b-button v-if="checkClaim(CAN_POST_PAYMENT)" size="sm" class="mr-2" title="Expenses List" variant="primary" @click="expensePage()">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </b-button>
                  <b-button v-if="checkClaim(CAN_POST_PAYMENT)" size="sm" class="mr-2" title="Add Expense" variant="primary" @click="expensePage(true)">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </b-button>
                </div>
              </div>
            </template>
            <grid-component
              :gridId="expenseGridId"
              :itemData="expenseSummaryData"
              :fields="expensesFields"
              :styleCustom="'height: 170px'"
              :onEdit="redirectExpenses"
            />
          </b-card>
        </b-row>
      </b-col>
    </b-row>
  </section>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import FixedHeader from '@/shared/components/FixedHeader/indexNew';
  import GridComponent from '@/shared/components/GridComponent';
  import Invoices from '@/shared/components/Invoices';
  import PurchaseOrders from '@/shared/components/PurchaseOrders';
  import ServiceOrders from '@/shared/components/ServiceOrders';
  import ChartsOfAccounts from './components/ChartsOfAccounts';
  import {expensesFields,credtMemoSummaryFields, revenueFields} from './fields'
  import { GRID_ID } from '@/shared/constants';
  export default {
    components: {
      FixedHeader,
      GridComponent,
      Invoices,
      PurchaseOrders,
      ChartsOfAccounts,
      ServiceOrders,
    },
    metaInfo: () => ({
      title: 'Accounting',
    }),
    data() {
      return {
        expensesFields:expensesFields,
        revenueFields:revenueFields,
        credtMemoSummaryFields:credtMemoSummaryFields,
        revenueGridId: GRID_ID.ACCOUNT_REVENUE_GRID,
        expenseGridId: GRID_ID.ACCOUNT_EXPENSE_GRID,
        creditMemoGridId: GRID_ID.ACCOUNT_CREDIT_MEMO,
        isClear:false,
        selectedInvoiceRow: {},
        // summeryCardHeight:{
        //   'max-height': (screen.height / 3) + `px`,
        //   height: ((screen.height / 3) - 50) + `px`
        // }
      };
    },
    computed: {
      ...mapGetters('creditMemos', ['creditMemoSummary']),
      ...mapGetters('invoices', ['revenueSummary']),
      ...mapGetters('expenses', ['expenseSummary']),
      creditMemoitemData(){
        return this.creditMemoSummary;
      },
      revenueSummaryData(){
        return this.revenueSummary;
      },
      expenseSummaryData(){
        return this.expenseSummary;
      }
    },
    methods: {
      ...mapActions('creditMemos', ['getCreditMemoSummary']),
      ...mapActions('invoices', ['getRevenueSummary']),
      ...mapActions('expenses', ['getExpenseSummary']),
      expensePage(isAdd=false){
        this.$router.push({
          name: 'Expenses',
          params: { isAdd: isAdd },
        });
      },
      creditPage(isAdd=false){
        this.$router.push({
          name: 'CreditMemos',
          params: { isAdd: isAdd },
        });
      },
      invoiceRowSelect(row){
        this.selectedInvoiceRow = row
      },
      redirectToReceivePayment(){
        this.$router.push({
          name: 'receivepayments.add',
          params: {
            suggestion: { id: this.selectedInvoiceRow.companyId, name: this.selectedInvoiceRow.companyName },
            total: this.selectedInvoiceRow.total,
          },
        });
      },
      redirectCreditMemo(row){
        this.$router.push({
          name: 'CreditMemos',
          params: {
            companyName: row.companyName,
          },
        });
      },
      redirectExpenses(row){
        this.$router.push({
          name: 'Expenses',
          params: {
            accountName: row.accountName,
          },
        });
      },
      redirectInvoices(row){
        this.$router.push({
          name: 'invoices',
          params: {
            companyName: row.name,
            statisticFilter: true
          },
        });
      }
    },
    mounted() {
      /*console.log(window.innerHeight);*/
    },
    beforeMount() {
      if('clear' in this.$route.query) {
        this.isClear=true;
        this.clearRoute();
      }else{
        this.getCreditMemoSummary();
        this.getExpenseSummary();
        this.getRevenueSummary();
      }
    }
  };
</script>
<style lang="scss">
  .buttons-panel {
    text-align: center;
  }
</style>
